export default __webpack_public_path__ + "static/media/T5WBeforeAfter.72d958344afc63df75584aabbcef0eb7.png";